/**
 * @author       jordan.sookikian@zumper.com (Jordan Sookikian)
 * @copyright    Copyright (c) 2021, Zumper
 */

import type { RenterQuestion } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { SET_RENTER_QUESTIONS } from '../constants/index'

export const setRenterQuestions = createAction<
  readonly RenterQuestion[],
  typeof SET_RENTER_QUESTIONS
>(SET_RENTER_QUESTIONS)
